/** Sound file mappings shared by the VIF board games (win/lose/timeout chimes). */
export const VIF_BOARD_SOUND_FILES: Readonly<Record<string, string>> = {
  correct: 'win2-vif.mp3',
  incorrect: 'lose2.mp3',
  timeout: 'lose3.mp3',
  win: 'magic-florish.mp3',
};

/** Auditory Memory facts-with-answers sound files, set one (2x2 through 4x9). */
export const AUDITORY_MEMORY_SOUND_FILES_SET_ONE: Readonly<
  Record<string, string>
> = {
  fa22: 'factswanswers/2 2 is 4.mp3',
  fa23: 'factswanswers/2 3 is 6.mp3',
  fa24: 'factswanswers/2 4 is 8.mp3',
  fa25: 'factswanswers/2 5 is 10.mp3',
  fa26: 'factswanswers/2 6 is 12.mp3',
  fa27: 'factswanswers/2 7 14.mp3',
  fa28: 'factswanswers/2 8 16.mp3',
  fa29: 'factswanswers/2 9 18.mp3',
  fa33: 'factswanswers/3 3 is 9.mp3',
  fa34: 'factswanswers/3 4 is 12.mp3',
  fa35: 'factswanswers/3 5 15.mp3',
  fa36: 'factswanswers/3 6 18.mp3',
  fa37: 'factswanswers/3 7 21.mp3',
  fa38: 'factswanswers/3 8 24.mp3',
  fa39: 'factswanswers/3 9 27.mp3',
  fa44: 'factswanswers/4 4 16.mp3',
  fa45: 'factswanswers/4 5 20.mp3',
  fa46: 'factswanswers/4 6 24.mp3',
  fa47: 'factswanswers/4 7 28.mp3',
  fa48: 'factswanswers/4 8 32.mp3',
  fa49: 'factswanswers/4 9 36.mp3',
};

/** Auditory Memory facts-with-answers sound files, set two (5x5 through 9x9). */
export const AUDITORY_MEMORY_SOUND_FILES_SET_TWO: Readonly<
  Record<string, string>
> = {
  fa55: 'factswanswers/5 5 25.mp3',
  fa56: 'factswanswers/5 6 30.mp3',
  fa57: 'factswanswers/5 7 35.mp3',
  fa58: 'factswanswers/5 8 40.mp3',
  fa59: 'factswanswers/5 9 45.mp3',
  fa66: 'factswanswers/6 6 36.mp3',
  fa67: 'factswanswers/6 7 42.mp3',
  fa68: 'factswanswers/6 8 48.mp3',
  fa69: 'factswanswers/6 9 54.mp3',
  fa77: 'factswanswers/7 7 49.mp3',
  fa78: 'factswanswers/7 8 56.mp3',
  fa79: 'factswanswers/7 9 63.mp3',
  fa88: 'factswanswers/8 8 64.mp3',
  fa89: 'factswanswers/8 9 72.mp3',
  fa99: 'factswanswers/9 9 81.mp3',
};
